export const emailDefaultTextColour = '#03152D';
export const emailDefaultBackgroundColour = 'white';
export const emailFontFamily =
  '"Titillium Web", Titillium, Segoe UI, Tahoma, Geneva, Verdana, sans-serif';
export const emailHeaderFontSize = '40px';
export const emailDefaultFontSize = '12pt';
export const tableHeaderColour = '#3A2050';
export const tableHeaderTextColour = 'white';
export const tableSubHeaderColour = '#B2B2B2';
export const tableBorderColour = '#03152D';
export const linkColour = '#4BBF7C';
export const tableWidth = '600px';
export const tableQuartersCellWidth = '150px';
export const tableCellWidth = '300px';
export const astrixFontSize = '8pt';
export const disclaimerFontSize = '8pt';
export const copyrightFontSize = '8pt';

export const cellBaseStyle = {
  textAlign: 'left' as const,
  padding: '2px 8px',
  border: `1px solid ${tableBorderColour}`,
  fontFamily: emailFontFamily,
  fontSize: emailDefaultFontSize,
  width: tableCellWidth,
};

export const fullWidthCellStyle = {
  ...cellBaseStyle,
  width: tableWidth,
};

export const quarterWidthCellStyle = {
  ...cellBaseStyle,
  width: tableQuartersCellWidth,
};
